let showSelectionM;
let Xstart;
let Ystart;
let canvasPageMarginTop = 0;
let canvasPageMarginLeft = 0;
let mouseDown = false;
let selectedObjects = [];

/** Pixels the pointer must move before the marquee appears (avoids jitter on click). */
const MARQUEE_DRAG_THRESHOLD_PX = 5;

export const drawDiv = (
  event,
  showSelection,
  XstartM,
  YstartM,
  setMultiSelect,
  tempLayer,
) => {
  let dontSelect = true;
  if (tempLayer.current.length < 1) return;

  tempLayer.current.forEach((element) => {
    if (element.componentStyles.hideBoolean !== true) dontSelect = false;
  });

  if (dontSelect) return;
  // set a variable that indicates the user is drawing a selection
  if (document.getElementById("canvas-page") !== null) {
    // canvasPageMarginTop = parseInt(
    //   window.getComputedStyle(document.getElementById("canvas-page")).marginTop
    // );
    // canvasPageMarginLeft = parseInt(
    //   window.getComputedStyle(document.getElementById("canvas-page")).marginLeft
    // );
  }
  showSelection = true;
  mouseDown = true;
  showSelectionM = false;

  Xstart = event.pageX;
  Ystart = event.pageY;
  const canvas = event.currentTarget;

  // Get the bounding rectangle of the canvas
  const rect = canvas.getBoundingClientRect();

  // Calculate the starting position of the selection rectangle
  let Xxstart = event.clientX - rect.left + canvas.scrollLeft; // Add scrollLeft
  let Yystart =
    event.clientY - rect.top + canvas.scrollTop + canvasPageMarginTop; // Add scrollTop
  // let selection = multiSelect;
  setMultiSelect({ width: 0, height: 0, left: Xxstart, top: Yystart });

  // document.getElementById("mainCanvasContainer").onmousemove = mousedrag;

  document.addEventListener("onmouseup", closeSelec);
  document.onmouseup = closeSelec;
};

export function mousedrag(
  event,
  tempLayer,
  showSelection,
  XstartM,
  YstartM,

  setMultiSelect,
  setMultiSelectedComps,
  multiSelect,
  multiSelectionOfComponents,
) {
  if (!mouseDown) return;
  if (document.getElementById("canvas-page") !== null) {
  }
  // if we are making a selection lets keep updating our select box dimensions
  let pos1 = Xstart - event.clientX;
  let pos2 = Ystart - event.clientY;

  let leftValue =
    event.clientX - event.currentTarget.getBoundingClientRect().left;
  let Yvalue = event.clientY - event.currentTarget.getBoundingClientRect().top;
  let dragELement = document.getElementById("drawSelectionDiv");

  if (!showSelectionM) {
    const moved =
      Math.abs(event.pageX - Xstart) > MARQUEE_DRAG_THRESHOLD_PX ||
      Math.abs(event.pageY - Ystart) > MARQUEE_DRAG_THRESHOLD_PX;
    if (!moved) return;
    showSelectionM = true;
  }

  if (showSelectionM === true) {
    document.getElementById("mainCanvasContainer").onClick = null;
    const canvas = event.currentTarget;
    const rect = canvas.getBoundingClientRect();
    if (event.pageX > Xstart) {
      // left to right
      dragELement.style.width = event.pageX - Xstart + "px";
    } else {
      // right to left
      dragELement.style.width = Xstart - event.pageX + "px";
      dragELement.style.left =
        event.clientX - rect.left + canvas.scrollLeft + "px";
    }

    // vertical selection
    if (event.pageY > Ystart) {
      // top to bottom
      dragELement.style.height = event.pageY - Ystart + "px";
    } else {
      // bottom to top
      dragELement.style.height = Ystart - event.pageY + "px";
      dragELement.style.top =
        event.clientY -
        rect.top +
        canvas.scrollTop +
        canvasPageMarginTop +
        "px";
    }
  }
  let selectedObjs = [];
  tempLayer.current.forEach((obj, index) => {
    tempLayer.current[index].multiSelected = false;
    if (
      overLap(
        dragELement?.getBoundingClientRect(),
        document?.getElementById(obj.id)?.getBoundingClientRect(),
        // obj.componentStyles
      )
    ) {
      tempLayer.current[index].multiSelected = true;

      selectedObjs.push(obj);
    }
  });
  selectedObjects = selectedObjs;
  setMultiSelectedComps(selectedObjs);
  if (tempLayer.current[tempLayer.current.length - 1]) {
    tempLayer.current[tempLayer.current.length - 1].mulSelected = "yes";
  }
  setMultiSelect({
    ...multiSelect,
    pointerX: event.clientX,
    pointerY: event.clientY,
    timestamp: new Date().getTime(),
  });
}

export function overLap(domRect1, domRect2) {
  return (
    domRect1.top <= domRect2.top &&
    domRect1.left <= domRect2.left &&
    domRect1.bottom >= domRect2.bottom &&
    domRect1.right >= domRect2.right
  );
}
export const closeSelec = (showSelection) => {
  mouseDown = false;
  showSelectionM = false;
  document.getElementById("mainCanvasContainer").onmousemove = null;
  document.onmouseup = null;
  document.getElementById("drawSelectionDiv").style.width = 0 + "px";
  document.getElementById("drawSelectionDiv").style.height = 0 + "px";
};

export const pasteMultiSelectedComps = (
  count,
  setCount,
  setShowPaste,
  setVisibility,
  layerCompData,
  setLayerCompData,
  copiedComponent,
  countZindex,
  multiSelectedComps,
  setMultiSelectedComps,
  componentType,
  imageOnCanvas,
  setSelectedComponent,
  selectedComponent,
) => {
  let localCount = count;
  let localCountZindex = countZindex;
  let copiedObjects = JSON.parse(JSON.stringify(copiedComponent));

  let tempLayerCompData = [];

  let modifiedObjects = copiedObjects.map((element, index) => {
    let elemCSSProp = {},
      compType = "",
      coOrdinates = {},
      constructObj = "";
    elemCSSProp = Object.assign({}, element.componentStyles);
    coOrdinates.x = elemCSSProp.left + 25;
    coOrdinates.y = elemCSSProp.top + 50;
    elemCSSProp.froalaText = element.froalaText;

    // element.multiSelected = false;
    if (element.componentType === "Text" || element.componentType === "Shape") {
      compType = element.textComponentType.addContent;
      elemCSSProp.textComponentType = element.textComponentType;
      elemCSSProp.src =
        element.triImage || element.hexImage || element.pentImage;
      elemCSSProp.layerName =
        element.componentType === "Shape" ? "Shape" : "Text"; // Hack
    } else {
      elemCSSProp.layerName = compType = element.componentType;
    }

    if (compType === "Image") {
      constructObj = imageOnCanvas(
        "fromGetAssets",
        elemCSSProp.background,
        coOrdinates.x,
        coOrdinates.y,
        elemCSSProp.filename,
        elemCSSProp,
        elemCSSProp.width,
        elemCSSProp.height,
        localCount,
      );
    } else {
      constructObj = componentType[compType](
        coOrdinates,
        null,
        elemCSSProp,
        localCount,
      );
    }

    tempLayerCompData = [...tempLayerCompData, constructObj];
    setLayerCompData([...layerCompData, ...tempLayerCompData]);
    localCount++;

    let tempSelected = { ...constructObj };
    tempSelected.componentStyles.lockBoolean = false;
    if (typeof setSelectedComponent === "function") {
      setSelectedComponent(tempSelected);
    }
  });
  setCount(localCount);
  setShowPaste(false);
  setVisibility(false);
  setMultiSelectedComps([]);
};
export const deleteMultiSelectedComps = (
  event,
  setOpenTimelinePopup,
  layerCompData,
  setLayerCompData,
  multiSelectedComps,
  setMultiSelectedComps,
  animationObject,
  setAnimationObject,
  setSeconds,
  setMillSeconds,
  setSelectedComponent,
  setVisibility,
  claimArray,
  referenceFootnoteObj,
  setClaimsArray,
  setClaimReferencesFoonotes,
  compArray,
  matchTextArray,
  setDroppedComponentIds,
  setDroppedTextIds,
) => {
  setOpenTimelinePopup({
    popupWindow: false,
    fromUnRedo: false,
  });
  const filteredComponents = layerCompData.filter(
    (item) => !multiSelectedComps.includes(item),
  );

  const tempComps = compArray;
  const tempTextids = matchTextArray;
  const tempClaims = claimArray;
  const footnotes = referenceFootnoteObj.footnotes;
  const references = referenceFootnoteObj.references;
  const abbreviation = referenceFootnoteObj.abbreviation;
  const selectedClaimIds = multiSelectedComps.map((obj) => obj.claimId);
  const selectedCompIds = multiSelectedComps.map((obj) => obj.componentId);
  const selectedMatchTextIds = multiSelectedComps.map((obj) => obj.matchTextId);

  const updatedFootnotes = footnotes.filter(
    (claim) => !selectedClaimIds.includes(claim.claimId),
  );
  const updatedReferences = references.filter(
    (claim) => !selectedClaimIds.includes(claim.claimId),
  );
  const updatedAbbreviation = abbreviation.filter(
    (claim) => !selectedClaimIds.includes(claim.claimId),
  );
  const updatedClaimsArray = tempClaims.filter(
    (claimId) => !selectedClaimIds.includes(claimId),
  );
  const updatedCompsArray = tempComps?.filter(
    (id) => !selectedCompIds.includes(id),
  );
  const updatedMatchTextArray = tempTextids?.filter(
    (id) => !selectedMatchTextIds.includes(id),
  );

  setClaimsArray(updatedClaimsArray);
  setDroppedComponentIds(updatedCompsArray);
  setDroppedTextIds(updatedMatchTextArray);
  setClaimReferencesFoonotes({
    footnotes: updatedFootnotes,
    references: updatedReferences,
    abbreviation: updatedAbbreviation,
  });

  if (event !== "fromKey" && Object.values(animationObject).length > 0) {
    let tempAnimationObj = {};
    for (let props in animationObject) {
      multiSelectedComps.forEach((selectedComp) => {
        if (props !== selectedComp.id)
          tempAnimationObj[props] = animationObject[props];
      });
    }
    setAnimationObject(tempAnimationObj);
  }
  if (layerCompData.length === 1) {
    setMillSeconds(0);
    setSeconds(0);
  }
  // setCompDeleted(true);
  setSelectedComponent("compdeleted");
  setLayerCompData(filteredComponents);
  setVisibility(false);
  setMultiSelectedComps([]);
};
